module.exports = __webpack_public_path__ + "static/media/caveWalls.711c0ba6.png";